import { Chip, ChipPicker, ListItem } from '@tableau/widgets';
import React from 'react';

import { cssClass } from '../../../style';


/**
 * This is a wrapper tsx that makes the ChipPicker widget more suitable to the purposes of dataroles.
 */

export interface EnumChipPickerProps<E extends string> {
  readonly placeholder: string;
  readonly label: string;
  readonly testId: string;
  readonly values: E[];
  readonly onChange: (newValues: string[]) => void;
  readonly enumValues: E[];
  readonly friendlyNames: Record<E, string>;
  readonly style?: React.CSSProperties;
}

export interface EnumChipPickerState {
  readonly filterText: string;
}
const cssPrefix = 'EnumChipEditor';
const labelElim = cssClass(cssPrefix, 'labelElimination', {
  $nest: {
    '& label': {
      display: 'none',
    },
  },
});

export class EnumChipPicker<E extends string> extends React.PureComponent<EnumChipPickerProps<E>, EnumChipPickerState> {
  public state = {
    filterText: '',
  };

  public render(): JSX.Element  {
    return <div className={labelElim} style={this.props.style}>
    <ChipPicker
      label={this.props.label}
      placeholder={this.props.placeholder}
      testId={this.props.testId}
      listItems={this.currentResults}
      onValueAdd={this.handleValueAdd}
      onValuesChange={this.handleValuesChange}
      onFilterItems={this.handleFilterItems}
      >
      {this.props.values.map((value: E, i: number) =>
        <Chip
          key={i}
          tooltip={value}
          value={value}
          >
        {this.props.friendlyNames[value]}
        </Chip>
      )}
    </ChipPicker>
    </div>;
  }

  private get currentResults(): ListItem[] {
    const filterText = this.state.filterText.trim();
    return this.props.enumValues
      .filter((value: E) => value.toLowerCase().indexOf(filterText.toLowerCase()) > -1 || this.props.friendlyNames[value].toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) > -1)
      .map((value: E) => ({value, disabled: this.props.values.indexOf(value) > -1, content: <>{this.props.friendlyNames[value]}<span style={{ float: 'right', color: 'rgba(0,0,0,0.56)' }}>[{value}]</span></>,}));
  }

  private handleFilterItems = (s: string) => this.setState({filterText: s});

  private handleValuesChange = (values: string[]) => this.props.onChange(values);

  private handleValueAdd = (value: E, id: number) => {
    const newValues = [...this.props.values];
    newValues.splice(id, 0, value);
    this.props.onChange(newValues);
  }
}
